import Typography from '@mui/material/Typography';
import React, { useContext } from 'react';
import { ComponentContext } from '../../ContextWrappers/NRComponentContextWrapper';
import { CONSTANTS } from '../../constants/constants';
import Box from '@mui/material/Box';
import { Tooltip } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import NRShowAssetStatusStyles from './NRShowAssetStatus.styles';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CircularProgress from '@mui/material/CircularProgress';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import NRRefreshIcon from '../../NRIcons/NRRefreshIcon';
const useStyles = makeStyles(NRShowAssetStatusStyles);

function NRShowAssetStatus() {
  const classes = useStyles();
  const { pathname } = useLocation();
  const { asset, latestAssetStatus, isLatestAsset } = useContext(ComponentContext);
  const navigate = useNavigate();
  const { tab, subTab, assetGroupId } = useParams();

  const navigateToLatestAsset = () => {
    if (pathname.startsWith('/assets')) {
      navigate(`/assets/${latestAssetStatus.assetId}${!!tab ? '/' + tab : ''}${!!subTab ? '/' + subTab : ''}`, { replace: true });
    } else if (pathname.startsWith('/groups') && !!assetGroupId) {
      navigate(`/groups/${assetGroupId}/${latestAssetStatus.assetId}${!!tab ? '/' + tab : ''}${!!subTab ? '/' + subTab : ''}`, { replace: true });
    }
    window.location.reload();
  };

  return (
    <Box>
      {!!isLatestAsset && !latestAssetStatus?.hasRunningJob && (
        <Box display={'flex'} alignItems={'center'}>
          <Typography ml={1} variant={'body2'} color={'unset'}>
            Report is up to date
          </Typography>
        </Box>
      )}
      {!!asset?.id && !!latestAssetStatus?.hasRunningJob && (
        <Box display={'flex'} alignItems={'center'}>
          <CircularProgress color="primary" size={14} sx={{ mr: 1 }} />

          <Typography variant={'body2'} color={'unset'}>
            Report is updating...
          </Typography>
          <Tooltip title={CONSTANTS.REPORT.UPDATING_TOOLTIP}>
            <InfoOutlinedIcon className={classes.infoIcon} fontSize={'small'} />
          </Tooltip>
        </Box>
      )}
      {!!latestAssetStatus && !!asset?.id && isLatestAsset === false && !latestAssetStatus?.hasRunningJob && (
        <Box display={'flex'} alignItems={'center'}>
          <NRRefreshIcon />
          <Typography ml={1} variant={'body2'} color={'unset'}>
            <span>New report data is available, </span>
            <span className={classes.link} onClick={navigateToLatestAsset}>
              click here
            </span>
            <span> to refresh</span>
          </Typography>
        </Box>
      )}
    </Box>
  );
}

export default NRShowAssetStatus;
